import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        // <main className="flex-grow flex flex-col items-center text-center px-4 pt-8 lg:pt-16 pb-20 relative z-10 border border-grey">
        <main className="flex-grow flex flex-col items-center text-center px-4 pt-8 lg:pt-16 pb-20 relative z-10">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-[#5c3e21] mb-6 tracking-wide drop-shadow-sm">
                LAUNCHING SOON
            </h1>
            <p className="text-xl md:text-2xl font-bold mb-12 sm:mb-16">
                {/* <p className="text-base sm:text-lg md:text-2xl font-bold mb-12 sm:mb-16 px-2"></p> */}
                Empowering tutors, schools &amp; learners through AI driven education
            </p>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto w-full px-2"> */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full px-2 mx-[30%]"> */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full lg:px-10">
                {/* Card 1 */}
                <div className="bg-glass rounded-2xl p-6 sm:p-8 text-left overflow-hidden relative" style={{ border: '2px solid black' }}>
                    <h2 className="text-[#8c5021] text-3xl font-black mb-3">About Us</h2>
                    <p className="text-black font-semibold text-lg leading-snug">
                        Smart Acharya is an advanced EdTech platform, redefining the future of learning. At Smart Acharya, we combine the power of Artificial Intelligence with modern education to create smarter, more personalised, and engaging learning experiences 
                        <Link
                            to="/about-us"
                            className="text-black-800 font-bold hover:underline"
                        >
                            {` `}(Read more...) 
                        </Link>
                    </p>
                </div>

                {/* Card 2 */}
                <div className="bg-glass rounded-2xl p-6 sm:p-8 text-left overflow-hidden relative" style={{ border: '2px solid black' }}>
                    <h2 className="text-[#8c5021] text-3xl font-black mb-3">Who we Serve</h2>
                    <p className="font-bold text-black text-lg mb-1">One platform - four communities</p>
                    <p className="text-black font-semibold text-lg leading-snug">
                        Smart Acharya serves students and parents, tutors, schools and tutoring centres, and corporates each with their own dedicated environment
                        <Link
                            to="/who-we-serve"
                            className="text-black-800 font-bold hover:underline"
                        >
                            {` `}(Read more...) 
                        </Link>
                    </p>
                </div>

                {/* Card 3 */}
                <div className="bg-glass rounded-2xl p-6 sm:p-8 text-left overflow-hidden relative" style={{ border: '2px solid black' }}>
                    <h2 className="text-[#8c5021] text-3xl font-black mb-3">What we Offer</h2>
                    <p className="font-bold text-black text-lg mb-1">Your teachers, Your content, Made intelligent</p>
                    <p className="text-black font-semibold text-lg leading-snug">
                        Smart Acharya gives schools and tutoring centres their own secure, private platform environment, AI powered, built around their existing teachers and curriculum
                        <Link
                            to="/what-we-offer"
                            className="text-black-800 font-bold hover:underline"
                        >
                            {` `}(Read more...) 
                        </Link>
                    </p>
                </div>

                {/* Card 4 */}
                <div className="bg-glass rounded-2xl p-6 sm:p-8 text-left overflow-hidden relative" style={{ border: '2px solid black' }}>
                    <h2 className="text-[#8c5021] text-3xl font-black mb-3">Subjects & Disciplines</h2>
                    <p className="font-bold text-black text-lg mb-1">Your expertise, Made permanent, Made scalable</p>
                    <p className="text-black font-semibold text-lg leading-snug">
                        Smart Acharya gives organisations an internal knowledge platform, so what your best people know does not leave when they do. Expert on demand, culturally intelligent, measurable 
                        <Link
                            to="/subjects-and-disciplines"
                            className="text-black-800 font-bold hover:underline"
                        >
                            {` `}(Read more...) 
                        </Link>
                    </p>
                </div>
            </div>
        </main>
    );
};

export default HomePage;
